import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { productsSelector } from "../../../redux/magento/selectors/magento.selectors";
import { Routes } from "../../../routes";
import { useState } from "react";
import localForage from "localforage";

export const useFreyaSetup = () => {
  const ZONE_KEY = "zone";

  const history = useNavigate();
  const products = useSelector(productsSelector);
  const [isLoading, setIsLoading] = useState(true);

  const checkProducts = () => {
    if (!products?.length) {
      history(Routes.freya);
    }
    setIsLoading(false);
  };

  const saveZoneToCache = (zone: string) => {
    localForage.setItem(ZONE_KEY, zone);
  };

  const getSavedZoneFromCache = async (): Promise<string | null> => {
    return await localForage.getItem(ZONE_KEY);
  };

  return {
    checkProducts,
    isLoading,
    zone: {
      set: saveZoneToCache,
      get: getSavedZoneFromCache
    }
  };
};
